import http from "../common/api";
import {ApiSettings} from "application";
import dayjs from "dayjs";
import {omit} from "presentation/common/helpers/utils";

export const namesStrategy = {
    cav: {
        compactName: "CAV",
        name: "Certificado de Anotaciones Vigentes",
    },
    comprobante_banco: {
        compactName: "Comprobante Banco",
        name: "Comprobante Banco",
    },
    contrato_activacion_tag: {
        compactName: "Convenio TAG",
        name: "Convenio TAG",
    },
    factura: {
        compactName: "Factura",
        name: `Factura`,
    },
    formulario_88: {
        compactName: "Formulario 88",
        name: "Formulario 88",
    },
    homologado: {
        compactName: "CHI-E",
        name: `Certificado de Homologación (CHI-e)`,
    },
    mlt: {
        compactName: "MLT",
        name: "Certificado Multas No Pagadas (MLT)",
    },
    nota_credito: {
        compactName: "Nota de Crédito",
        name: "Nota de Crédito",
    },
    padron: {
        compactName: "Padrón",
        name: `Certificado de Inscripción (Padrón)`,
    },
    permiso_circulacion: {
        compactName: "PCV",
        name: `Permiso de Circulación Vehicular (PCV)`,
    },
    revision_tecnica: {
        compactName: "Revisión Técnica",
        name: "Revisión Técnica",
    },
    seguro_obligatorio: {
        compactName: "SOAP",
        name: `Certificado SOAP`,
    },
    solicitud_primera_inscripcion: {
        compactName: "Solicitud Primera Inscripción",
        name: "Solicitud Primera Inscripción",
    },
    tarjeta_vehicular: {
        compactName: "Tarjeta Vehicular",
        name: "Tarjeta Vehicular",
    },
    idai_poder_simple: {
        compactName: "Poder Simple",
        name: "Poder Simple",
    }
};
export const DOCUMENT_TYPES = [
    "solicitud_primera_inscripcion",
    "contrato_activacion_tag",
    "permiso_circulacion",
    "formulario_88",
    "factura",
    "seguro_obligatorio",
    "comprobante_banco",
    "tarjeta_vehicular",
    "homologado",
    "padron",
    "nota_credito",
    "cav",
    "mlt",
    "revision_tecnica",
    "idai_poder_simple"
];

const getDocumentDetail = async (unique_id) => {
    try {
        const response = await http.post(ApiSettings.getDocumentDetail, {
            unique_id,
        });

        const items = response?.data?.result?.documentos
            ?.filter(
                (doc) => DOCUMENT_TYPES.includes(doc.type) && namesStrategy[doc.type]
            )
            ?.sort(
                (doc1, doc2) =>
                    dayjs(doc2.inserted_at).valueOf() - dayjs(doc1.inserted_at).valueOf()
            );

        const docsGroupByType = items?.reduce((acc, doc) => {
            if (!acc[doc.type]) {
                acc[doc.type] = [];
            }

            acc[doc.type].push(doc);
            return acc;
        }, {});

        const order = [
            "factura",
            "nota_credito",
            "solicitud_primera_inscripcion",
            "idai_poder_simple",
            "padron",
            "cav",
            "mlt",
            "revision_tecnica",
            "homologado",
            "seguro_obligatorio",
            "permiso_circulacion",
            "contrato_activacion_tag",
            "tarjeta_vehicular",
            "comprobante_banco",
            "formulario_88",
        ];

        const documents = order
            ?.map((docType) => docsGroupByType?.[docType] ?? [])
            .flat(2)
            ?.map((doc) => {
                const desc = namesStrategy[doc.type];

                return {
                    id: doc.unique_id,
                    ...desc,
                    canDelete: false,
                    createAt: dayjs(doc.inserted_at).format("DD/MM/YYYY"),
                    downloadUrl: `/nodeservice/download/tenant/doxautoinscripcion/node/${doc.unique_id}`,
                    fileName: `${desc.compactName}-${dayjs(doc.inserted_at).format(
                        "DD-MM-YYYY"
                    )}`,
                    type: doc.type,
                    url: `/nodeservice/preview/tenant/doxautoinscripcion/node/${doc.unique_id}`,
                };
            });

        return {
            ...response,
            data: {
                detailInfo: omit(response?.data?.result || {}, ["documentos"]),
                documents,
            },
        };
    } catch (error) {
        return error.response;
    }
};

export default getDocumentDetail;
